export const PUT_CURRENT_USER = 'PUT_CURRENT_USER';
export const PUT_CURRENT_PARTNER = 'PUT_CURRENT_PARTNER';
